import { ArrowUpRight } from "lucide-react";

/**
 * Leichter Inline-CTA für lange Artikel, hält die Kontaktaufnahme
 * jederzeit einen Klick entfernt, ohne den Lesefluss zu brechen.
 */
export function InlineCta({
  text = "Unsicher, welcher dieser Punkte in Ihrem Shop am meisten Umsatz kostet?",
  cta = "Kostenlose Einschätzung erhalten",
}: {
  text?: string;
  cta?: string;
}) {
  return (
    <aside className="my-10 rounded-lg border border-primary/30 bg-primary/5 p-5 md:flex md:items-center md:justify-between md:gap-6">
      <p className="text-sm leading-relaxed text-foreground md:max-w-lg">{text}</p>
      <a
        href="#anfrage"
        className="mt-4 inline-flex shrink-0 items-center gap-1.5 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5 md:mt-0"
      >
        {cta}
        <ArrowUpRight className="h-4 w-4" />
      </a>
    </aside>
  );
}
